import { configureStore, compose, combineReducers } from "@reduxjs/toolkit";
import authReducer from "src/slice/auth";
import dashboardReducer from "src/slice/dashboard";
import goodsInReducer from "src/slice/goodsin";
import dispatchOrderReducer from "src/slice/dispatchOrder";
import searchReducer from "src/slice/search";
import reportReducer from "src/slice/reports";
import depotUsers from "src/slice/depotUsers";
import clientProjects from "src/slice/clientProjects";
import lookupRedu from "src/slice/lookup";

import { getDefaultMiddleware } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // You can choose different storage options based on your needs

const persistConfig = {
  key: "root", // The key under which your persisted data will be stored in the storage
  storage, // The storage method (e.g., local storage, session storage, etc.)
};


// import { composeWithDevTools } from "redux-devtools-extension";

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  auth: authReducer.reducer,
  dashboard: dashboardReducer.reducer,
  goodsin: goodsInReducer.reducer,
  dispatch: dispatchOrderReducer.reducer,
  search: searchReducer.reducer,
  reports: reportReducer.reducer,
  depotUsers: depotUsers.reducer,
  clientProjects: clientProjects.reducer,
  lookup: lookupRedu.reducer,
});

const persistedReducer = persistReducer(persistConfig, combineReducers({
  lookup: lookupRedu.reducer,
}));


const Store = configureStore({
  reducer: rootReducer,
  middleware: [...getDefaultMiddleware()],
  devTools: true,
});

const Store1 = configureStore({
  reducer: persistedReducer,
  middleware: [...getDefaultMiddleware()],
  devTools: true,
});

const persistor = persistStore(Store1);

export { Store, persistor };


